import React from "react";
import Link from "../../components/Link";
import { styled } from "../../stitches.config";
import { bodyLarge } from "../commonStyles/Fonts";

interface CategoryChild {
    OID: number;
    name: string;
    path: string;
}

interface Category {
    name: string;
    childrens?: CategoryChild[];
}

interface CategoryLinksProps {
    category: Category;
}

const CategoryLinks: React.FC<CategoryLinksProps> = ({ category }) => {
    const children = category?.childrens ?? [];

    if (children.length === 0) {
        return null;
    }

    return (
        <div className="container">
            <div className="row">
                <Wrapper className={bodyLarge()}>
                    <p>{category.name}</p>

                    {children.map((child) => (
                        <Link
                            key={child.OID}
                            to={child.path}
                        >
                            {child.name}
                        </Link>
                    ))}
                </Wrapper>
            </div>
        </div>
    );
};

const Wrapper = styled("div", {
    width: "100%",
    display: "flex",
    whiteSpace: "nowrap",
    overflowY: "hidden",
    overflowX: "scroll",
    scrollbarWidth: "none",
    paddingBottom: "24px",
    paddingLeft: "6px",

    "@bp4": {
        paddingBottom: "40px"
    },
    "&::-webkit-scrollbar": {
        width: "0px",
    },

    "p": {
        color: "$grayscale100",
        background: "none",
        borderWidth: "0px",
        padding: "6px",
        position: "relative",
        marginLeft: "24px",
        margin: "0px",
        "&::after": {
            content: "",
            position: "absolute",
            left: "50%",
            bottom: "0",
            transform: "translateX(-50%)",
            width: "4px",
            height: "4px",
            backgroundColor: "$primary",
            borderRadius: "50%",
        },
    },

    "a": {
        color: "$grayscale100",
        background: "none",
        borderWidth: "0px",
        padding: "6px",
        position: "relative",
        marginLeft: "24px",
    },

    "& a:hover, & a:active": {
        textDecoration: "none",
    },
});

export default CategoryLinks;